// Календарная дата по местному времени. `new Date().toISOString().slice(0, 10)` даёт дату
// по UTC: с 00:00 до 03:00 по Москве это ещё вчера.

/** Дата по местному времени — «2026-11-03», как в `<input type="date">`. */
export function isoDate(d: Date): string {
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}

/** Сегодня по местному времени — «2026-11-03». */
export function todayIso(now: Date = new Date()): string {
  return isoDate(now);
}
